// extracted by mini-css-extract-plugin
module.exports = {"pnww6ig":"pnww6ig"};